import React from 'react'

const HeroComponent = ({ title, description }) => {
  return (
    <div className="hero">
      <div className="p-3 mx-auto text-center hero-content md:max-w-screen-sm sm:p-8">
        <h1 className="my-4 mt-8 text-5xl leading-none xl:text-6xl">{title}</h1>
        <div
          className="mt-0 text-xl leading-tight text-left"
          dangerouslySetInnerHTML={{ __html: description }}></div>
      </div>
    </div>
  )
}

export default HeroComponent
